import type { FunctionComponent } from "react";
import { CommentsAdminSliderPartial } from "../../../../partials/admin/menus/proposals/comments-proposal-slider.admin.partial";

export const CommentsAdminSliderScreen: FunctionComponent = () => {
  return <CommentsAdminSliderPartial />;
};
